import * as types from '../types.js';

const ICO_BOX = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><path d="M3.3 7 12 12l8.7-5M12 22V12"/></svg>';
const ICO_TAG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M20.6 13.4 12 4.8 4 4l.8 8 8.6 8.6a2 2 0 0 0 2.8 0l4.4-4.4a2 2 0 0 0 0-2.8z"/><circle cx="7.5" cy="7.5" r="1"/></svg>';
const ICO_LAYERS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="m12 3 9 5-9 5-9-5 9-5z"/><path d="m3 12 9 5 9-5"/><path d="m3 17 9 5 9-5"/></svg>';
const ICO_BAR = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M4 7h16M4 12h10M4 17h13"/></svg>';
const ICO_RULER = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M3 8h18v8H3z"/><path d="M7 8v3M11 8v4M15 8v3M19 8v5"/></svg>';

/**
 * Atualiza título, badges e cards a partir dos campos do cadastro.
 * @param {HTMLElement|null} root
 */
function syncPackagingPanel(root)
{
	if (!root)
		return;
	const val = (sel) =>
	{
		const el = root.querySelector(sel);
		return el ? String(el.value ?? '').trim() : '';
	};
	const setText = (sel, text) =>
	{
		root.querySelectorAll(sel).forEach((el) =>
		{
			el.textContent = text;
		});
	};
	const code = val('#code');
	setText('[data-sdp="title"]', code || 'Nova embalagem');
	setText('[data-sdp="product"]', val('#product_id') || '—');
	setText('[data-sdp="kpi-factor"]', val('#factor') || '0');
	const level = root.querySelector('#level');
	setText('[data-sdp="kpi-level"]', level?.selectedOptions?.[0]?.text?.trim() || '—');
	setText('[data-sdp="kpi-weight"]', val('#weight') || '0');
	setText('[data-sdp="kpi-gtin"]', val('#gtin') || '—');
	const badgeDefault = root.querySelector('[data-sdp="badge-default"]');
	const badgeDisabled = root.querySelector('[data-sdp="badge-disabled"]');
	if (badgeDefault)
		badgeDefault.hidden = !root.querySelector('#is_default')?.checked;
	if (badgeDisabled)
		badgeDisabled.hidden = !root.querySelector('#is_disabled')?.checked;
}

export default {
	html: `
		<form id="product-packaging" class="form sial-modal-form sial-detail sial-detail--edit" autocomplete="off">
			<datalist id="companies"></datalist>
			<datalist id="products"></datalist>
			<datalist id="manufacturers"></datalist>
			<header class="sdp-head">
				<div class="sdp-head-main">
					<div class="sdp-icon">${ICO_BOX}</div>
					<div class="sdp-head-copy">
						<p class="sdp-kicker">Cadastro de embalagem</p>
						<h2 class="sdp-title" data-sdp="title">Nova embalagem</h2>
						<div class="sdp-meta">
							<span>Produto: <b data-sdp="product">—</b></span>
							<span class="sdp-badge sdp-badge--free" data-sdp="badge-default" hidden>Padrão</span>
							<span class="sdp-badge sdp-badge--blocked" data-sdp="badge-disabled" hidden>Inativa</span>
						</div>
					</div>
				</div>
				<button type="button" class="bn_Escape sdp-close" title="Fechar" aria-label="Fechar">×</button>
			</header>
			<section class="sdp-kpis" aria-label="Resumo da embalagem">
				<div class="sdp-kpi sdp-kpi--total">
					<div class="sdp-kpi-label">${ICO_LAYERS} Fator</div>
					<div class="sdp-kpi-value"><span data-sdp="kpi-factor">0</span><span class="sdp-kpi-unit">un</span></div>
				</div>
				<div class="sdp-kpi sdp-kpi--avail">
					<div class="sdp-kpi-label">${ICO_TAG} Nível</div>
					<div class="sdp-kpi-value sdp-kpi-value--sm"><span data-sdp="kpi-level">—</span></div>
				</div>
				<div class="sdp-kpi sdp-kpi--reserved">
					<div class="sdp-kpi-label">${ICO_RULER} Peso</div>
					<div class="sdp-kpi-value"><span data-sdp="kpi-weight">0</span><span class="sdp-kpi-unit">kg</span></div>
				</div>
				<div class="sdp-kpi sdp-kpi--free">
					<div class="sdp-kpi-label">${ICO_BAR} GTIN</div>
					<div class="sdp-kpi-value sdp-kpi-value--sm"><span data-sdp="kpi-gtin">—</span></div>
				</div>
			</section>
			<section class="sdp-cols">
				<div class="sdp-block">
					<h3 class="sdp-block-title">${ICO_TAG} Identificação</h3>
					<div class="sdp-fields">
						<label title="Empresa">Empresa<sup>*</sup>
							<input id="company_id" type="text" list="companies" required>
						</label>
						<label title="Identificador da embalagem">ID
							<input id="id" type="text" disabled>
						</label>
						<label class="sdp-span-2" title="Produto">Produto<sup>*</sup>
							<input id="product_id" type="text" list="products" required>
						</label>
					</div>
				</div>
				<div class="sdp-block">
					<h3 class="sdp-block-title">${ICO_LAYERS} Estrutura</h3>
					<div class="sdp-fields">
						<label title="Código da embalagem">Código<sup>*</sup>
							<input id="code" type="text" placeholder="1X60" required>
						</label>
						<label title="Nível da embalagem">Nível<sup>*</sup>
							<select id="level" required>
								<option value="S">Secundária</option>
								<option value="T">Terciária</option>
								<option value="P">Primária</option>
							</select>
						</label>
						<label title="Fator de conversão">Fator<sup>*</sup>
							<input id="factor" type="text" placeholder="60" required>
						</label>
						<label title="Capacidade da embalagem terciária">Cap. terciária
							<input id="tertiary_capacity" type="text" placeholder="100">
						</label>
					</div>
					<div class="sdp-check-row">
						<label title="Embalagem padrão do produto para fatores/GTIN"><input id="is_default" type="checkbox"> Padrão</label>
						<label title="Cadastro inativo (não aparece em seleções)"><input id="is_disabled" type="checkbox"> Inativa</label>
					</div>
				</div>
			</section>
			<div class="sdp-stack">
				<div class="sdp-block">
					<h3 class="sdp-block-title">${ICO_BAR} Identificação comercial</h3>
					<div class="sdp-fields">
						<label title="Fabricante desta embalagem/GTIN — é o fabricante operacional do item quando esta embalagem é usada">Fabricante (GTIN)
							<input id="manufacturer_id" type="text" list="manufacturers" placeholder="Fabricante da embalagem">
						</label>
						<label title="EAN da embalagem">GTIN
							<input id="gtin" type="text" placeholder="EAN da embalagem">
						</label>
						<label class="sdp-span-2" title="Conteúdo ou identificador impresso no QR da etiqueta de embalagem">QR Code (etiqueta)
							<input id="qr_code" type="text" placeholder="Opcional" autocomplete="off">
						</label>
					</div>
					<p class="sdp-hint"><strong>Fabricante (GTIN):</strong> prevalece em estoque, entradas, saídas e relatórios quando esta embalagem é usada. Sem embalagem cadastrada, o sistema usa o fabricante do produto.</p>
					<p class="sdp-hint"><strong>GTIN:</strong> amarra o EAN desta embalagem (P/S/T) ao fabricante. O mesmo EAN pode existir em SKUs diferentes; na conferência por bip, prioriza a marcada como padrão.</p>
					<p class="sdp-hint"><strong>QR Code:</strong> payload opcional da etiqueta (código interno, GTIN+lote etc.) para relatórios, coletor ou geração de etiqueta.</p>
				</div>
				<div class="sdp-block">
					<h3 class="sdp-block-title">${ICO_RULER} Peso e dimensões</h3>
					<div class="sdp-fields">
						<label title="Peso de uma unidade desta embalagem (kg)">Peso (kg)
							<input id="weight" type="text" placeholder="0,000">
						</label>
						<label title="Altura da embalagem (cm)">Altura (cm)
							<input id="height" type="text" placeholder="0,000">
						</label>
						<label title="Largura da embalagem (cm)">Largura (cm)
							<input id="width" type="text" placeholder="0,000">
						</label>
						<label title="Comprimento da embalagem (cm)">Compr. (cm)
							<input id="length" type="text" placeholder="0,000">
						</label>
					</div>
					<p class="sdp-hint">Opcionais. Peso em <strong>kg</strong>; altura, largura e comprimento em <strong>cm</strong>. O peso alimenta o total na conferência de saída; as dimensões ficam para cubagem.</p>
				</div>
			</div>
			<div class="sdp-foot">
				<button class="bn_Escape button">Fechar</button>
				<button class="bn_Enter button">Salvar</button>
			</div>
		</form>
	`,
	form: {
		selector: '#product-packaging',
		init(formset) {
			formset.loadList('#companies', 'companies', { labels: ['nick'] });
			Object.getPrototypeOf(this).init.call(this);
			const orig = this.setValues.bind(this);
			this.setValues = (values) =>
			{
				orig(values);
				syncPackagingPanel(this.node);
			};
			this.node?.addEventListener('input', () => syncPackagingPanel(this.node));
			this.node?.addEventListener('change', () => syncPackagingPanel(this.node));
			syncPackagingPanel(this.node);
		},
		afterEditSetValues(formset) {
			const mfr = formset.form.getFieldBySelector('#manufacturer_id');
			const saved = mfr?.getValue?.();
			if (mfr && saved != null && saved !== '' && saved !== -1 && saved !== '-1')
				mfr.refresh();
			const root = formset.form.node;
			syncPackagingPanel(root);
			setTimeout(() => syncPackagingPanel(root), 400);
		},
	},
	fields: [
		{ properties: { selector: '#company_id' }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#id' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#product_id' }, types: [types.pubsub(), types.datalist(), types.observer('company_id'), types.obs_load_options('products', { labels: ['sku', 'name'] })] },
		{ properties: { selector: '#manufacturer_id' }, types: [types.pubsub(), types.datalist(), types.observer('company_id'), types.obs_load_options('manufacturers', { labels: ['nick', 'name'] })] },
		{ properties: { selector: '#code' }, types: [types.name()] },
		{ properties: { selector: '#level' }, types: [] },
		{ properties: { selector: '#factor' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#tertiary_capacity' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#gtin' }, types: [types.gtin(), types.caps()] },
		{ properties: { selector: '#qr_code' }, types: [types.name()] },
		{ properties: { selector: '#weight' }, types: [types.number(3)] },
		{ properties: { selector: '#height' }, types: [types.number(3)] },
		{ properties: { selector: '#width' }, types: [types.number(3)] },
		{ properties: { selector: '#length' }, types: [types.number(3)] },
		{ properties: { selector: '#is_default' }, types: [types.checkbox()] },
		{ properties: { selector: '#is_disabled' }, types: [types.checkbox()] },
	]
};
